import Button from "@cloudscape-design/components/button"
import SpaceBetween from "@cloudscape-design/components/space-between"
import UploadSourceDocumentButton from "./UploadSourceDocumentButton"

interface DataStreamContentActionsProps {
  /**
   * Whether the current user can edit the DTA (drives Save / Reupload visibility).
   */
  canEdit: boolean
  /**
   * Whether the editor has unsaved changes (enables Save).
   */
  hasUnsavedChanges: boolean
  /**
   * Whether a document save is in flight.
   */
  isSaving: boolean
  onSave: () => void
  /**
   * Re-extraction upload handler; undefined hides the Reupload button (non-DRAFT stages or
   * extraction in progress).
   */
  onUploadSourceDocument?: (file: File) => Promise<void>
}

/**
 * Content/document action buttons for a data stream: Reupload Source Document and Save. Rendered in
 * the SharedTabs `actions` slot so they sit on the same row as the tabs, right-aligned. Lifecycle
 * actions (Amend, workflow CTA) live in the page header (see DataStreamActions).
 */
const DataStreamContentActions = ({
  canEdit,
  hasUnsavedChanges,
  isSaving,
  onSave,
  onUploadSourceDocument,
}: DataStreamContentActionsProps) => {
  return (
    <SpaceBetween size="xs" direction="horizontal" alignItems="center">
      {canEdit && onUploadSourceDocument && (
        <UploadSourceDocumentButton onUpload={onUploadSourceDocument} />
      )}
      {canEdit && (
        <Button
          variant="normal"
          iconName="check"
          loading={isSaving}
          disabled={!hasUnsavedChanges || isSaving}
          onClick={onSave}
        >
          {isSaving ? "Saving..." : "Save"}
        </Button>
      )}
    </SpaceBetween>
  )
}

export default DataStreamContentActions
